import React, { useState, forwardRef, useRef, useEffect, useImperativeHandle } from 'react';
import { create_document } from '../api/api.js';
import { toast } from 'react-toastify';

const DocumentModal = forwardRef(({ teams, setTeams, isOpen, onClose }, ref) => {
  const [step, setStep] = useState(1);
  const [docName, setDocName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedTeams, setSelectedTeams] = useState([]);
  const maxDescriptionLength = 250;
  const [tipologia, setTipologia] = useState('campionati'); // default value

  const [teamSearch, setTeamSearch] = useState('');

  console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! teams");
  console.log(teams);


  const teamInputsRef = useRef({});

  useEffect(() => {
    // Initialize ref object with current alias and order
    const initial = {};
    teams.forEach(team => {
      initial[team.id] = {
        alias: team.alias ?? null,
        chapter: team.chapter ?? null,
        chapter_color: team.chapter_color ?? null,
        order: team.order ?? null,
      };
    });
    teamInputsRef.current = initial;
  }, [teams]);


  // Expose reset method to parent
  useImperativeHandle(ref, () => ({
    reset: () => {
      console.log("resetting");
      setStep(1);
      setDocName('');
      setDescription('');
      setSelectedTeams([]);
    }
  }));



  const createDocument = async() => {
    console.log("creating_document");
    console.log(docName);
    console.log(description);
    console.log(selectedTeams);
    var data = {}
    data.name = docName;
    data.description = description;
    data.teams = selectedTeams;
    data.tipologia = tipologia;

    data.user_id = localStorage.getItem("user_id");
    console.log(data);
    await create_document(data);
    toast.success("Richiesta caricata con successo. Il PDF è in fase di generazione. Riceverai una notifica al completamento dell'operazione.");
    onClose();
  }



  const handleNext = () => {
    if (step === 2) {
      // Apply alias and order changes from the ref

      const updatedTeams = teams.map(team => {
        const updates = teamInputsRef.current[team.id] || {};
        const updatedTeam = {
          ...team,
          alias: updates.alias ?? team.alias,
          chapter: updates.chapter ?? team.chapter,
          chapter_color: updates.chapter_color ?? team.chapter_color,
          order: updates.order ?? team.order,
          b_tier: updates.b_tier ?? team.b_tier,
          only_expiry: updates.only_expiry ?? team.only_expiry,
          checked: updates.checked ?? selectedTeams.some(t => t.id === team.id),


        };

        // Remove empty `order`
        if (updatedTeam.order === '' || updatedTeam.order === null) {
          delete updatedTeam.order;
        }
        // Remove empty `order`
        if (updatedTeam.alias === '' || updatedTeam.alias === null) {
          delete updatedTeam.alias;
        }
        // Remove empty `order`
        if (updatedTeam.chapter_color === '' || updatedTeam.chapter_color === null) {
          delete updatedTeam.chapter_color;
        }

        // Remove empty `order`
        if (updatedTeam.chapter === '' || updatedTeam.chapter === null) {
          delete updatedTeam.chapter;
        }

        return updatedTeam;
      });

      setTeams(updatedTeams);

      // 2. Build new selectedTeams based on checkboxes

      const newlySelected = updatedTeams.filter(team => {
        const updates = teamInputsRef.current[team.id];
        return updates?.checked ?? selectedTeams.some(t => t.id === team.id);
      });
      console.log(newlySelected);
      setSelectedTeams(newlySelected);
    }

    setStep(prev => Math.min(prev + 1, 3));
  };


  const handleBack = () => setStep(prev => Math.max(prev - 1, 1));
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container-big">
        <div className="modal-header">
          <h2 className="modal-title-document">Aggiungi documento</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>


        <div className="modal-content">

          <div className="modal-stepper">
            {['Info documento', 'Lista squadre', 'Conferma'].map((label, idx) => (
              <React.Fragment key={idx}>
                <div className={`step ${step > idx + 1 ? 'done' : step === idx + 1 ? 'current' : ''}`}>
                    {
                      step > idx + 1 &&
                      (
                      <div className="step-thing">
                        <div className="step-circle">
                        <span className="step-circle-done">&#10003;</span>
                        </div>
                        <span className="step-label">{idx+1}. {label}</span>
                      </div>
                      )
                    }
                    {
                      step === idx + 1 &&
                      (
                      <div className="step-thing">
                        <div className="step-circle inviz">
                          <span className="step-circle-done">&#10003;</span>
                        </div>
                        <span className="step-label orangetext">{idx+1}. {label}</span>
                      </div>
                      )
                    }
                    {
                      step < idx + 1 &&
                      (
                      <div className="step-thing">
                        <div className="step-circle inviz">
                          <span className="step-circle-done">&#10003;</span>
                        </div>
                        <span className="step-label">{idx+1}. {label}</span>
                      </div>
                      )
                    }

                </div>
                {idx < 2 && <span className="step-separator">&gt;</span>}
              </React.Fragment>
            ))}
          </div>

          <div className="modal-body">
            {step === 1 && (
              <div className="step-content">
                <div>
                  <label className="field-label">Nome documento</label>
                  <input
                    id="document_name"
                    type="text"
                    value={docName}
                    onChange={e => setDocName(e.target.value)}
                    className="field-input"
                  />
                </div>
                <div>
                  <label className="field-label">Descrizione</label>
                  <textarea
                    id="document_description"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    maxLength={maxDescriptionLength}
                    rows={4}
                    className="field-textarea"
                  />
                  <div className="field-counter">{description.length}/{maxDescriptionLength} caratteri</div>
                </div>
                <div>
                  <label className="field-label">Tipologia</label>
                  <div className="tipologia-toggle">
                    {['campionati', 'nazionali'].map(option => (
                      <label key={option} className="radio-label">
                        <input
                          type="radio"
                          name="tipologia"
                          value={option}
                          checked={tipologia === option}
                          onChange={() => setTipologia(option)}
                        />
                        <span className="custom-radio" />
                        {option.charAt(0).toUpperCase() + option.slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {step === 2 && (
              <div>
              <div className="team-search-bar">
                <input
                  type="text"
                  placeholder="Cerca squadra..."
                  value={teamSearch}
                  onChange={e => setTeamSearch(e.target.value)}
                  className="field-input"
                />
              </div>
                <div className="team-list-header">
                  <div className=""  style={{width:"30%"}}>Squadra</div>
                  <div className=""  style={{width:"22%"}}>Alias</div>
                  <div className=""  style={{width:"23%"}}>Nuovo Capitolo</div>
                  <div className=""  style={{width:"16%"}}>Leghe inferiori</div>
                  <div className=""  style={{width:"16%"}}>Solo scadenze</div>
                  <div className=""  style={{width:"12%", paddingRight:"10px", position:"relative"}}>Ordinamento</div>
                </div>
                <div className="team-list">
                  {teams
                  .filter(team => team.name.toLowerCase().includes(teamSearch.toLowerCase()))
                  .map(team => (
                  //{teams.map(team => (
                    <div className="team-item-outer" key={team.id}>
                      <div style={{width:"32%"}}>
                        <label  className="team-item">







<input
  type="checkbox"
  defaultChecked={teamInputsRef.current[team.id]?.checked ?? selectedTeams.some(t => t.id === team.id)}
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].checked = e.target.checked;
  }}
/>



                          <span>{team.name}</span>
                        </label>
                      </div>
                      <div className="center"  style={{width:"20%"}}>



<input
  className="team-item-alias"
  type="text"
  defaultValue={teamInputsRef.current[team.id]?.alias ?? team.alias ?? ""}
  placeholder="Alias..."
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].alias = e.target.value;
  }}
/>



                      </div>


                      <div className="center"  style={{width:"18%"}}>



<input
  className="team-item-chapter"
  type="text"
  defaultValue={teamInputsRef.current[team.id]?.chapter ?? team.chapter ?? ""}
  placeholder="Testo intestazione..."
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].chapter = e.target.value;
  }}
/>



                      </div>

                      <div className="center"  style={{width:"3%"}}>



<input
  className="team-item-color"
  type="color"
  defaultValue={teamInputsRef.current[team.id]?.chapter_color ?? team.chapter_color ?? ""}
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].chapter_color = e.target.value;
  }}
/>



                      </div>


                      <div className="center" style={{width:"20%"}}>




<input
  type="checkbox"
  defaultChecked={teamInputsRef.current[team.id]?.b_tier ?? team.b_tier ?? false}
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].b_tier = e.target.checked;
  }}
/>




                      </div>
                      <div className="center" style={{width:"20%"}}>



<input
  type="checkbox"
  defaultChecked={teamInputsRef.current[team.id]?.only_expiry ?? team.only_expiry ?? false}
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].only_expiry = e.target.checked;
  }}
/>



                      </div>
                      <div className="center" style={{width:"10%"}}>




<input
  className="team-item-order"
  type="number"
  defaultValue={teamInputsRef.current[team.id]?.order ?? team.order ?? ""}
  onChange={(e) => {
    if (!teamInputsRef.current[team.id]) teamInputsRef.current[team.id] = {};
    teamInputsRef.current[team.id].order = e.target.value;
  }}
/>
                      </div>

                    </div>
                  ))}
                </div>
              </div>
            )}

            {step === 3 && (
              <div className="confirmation">
                <div><strong>Nome documento:</strong> {docName || '-'}</div>
                <div><strong>Descrizione:</strong> {description || '-'}</div>
                <div><strong>Tipologia:</strong> {tipologia || '-'}</div>

                <div><strong>Squadre selezionate:</strong>
                  {selectedTeams.length ? (
                    <ol className="team-summary">
                      {selectedTeams.sort((a, b) => {
                        return a.order - b.order;
                      }).map(t => <li key={t.id}>{t.name}</li>)}
                    </ol>
                  ) : ' -'}
                </div>
              </div>
            )}
          </div>


        </div>

        <div className="modal-footer">
          {step > 1 && <button className="footer-btn btn-secondary" onClick={handleBack}>Indietro</button>}
          {step < 3 ? (
            <button className="footer-btn btn-primary" onClick={handleNext}>Avanti</button>
          ) : (
            <button className="footer-btn btn-success" onClick={createDocument}>Compila</button>
          )}
        </div>

      </div>
    </div>
  );
})

export default DocumentModal;

